import React, { useContext, useEffect, useState } from "react";
import { DataRequestContext } from "../../../context/DataRequestContext";
import { saveJsonToS3Bucket } from "../../../s3/DataRequest/SaveJSONToS3";
import ExternalFormSubmittedModal from "../../../Modals/ExternalFormSubmittedModal/ExternalFormSubmittedModal";
import "./submitform.css";
import { formatCSVData, retrieveData } from "../../../csv/JSONtoCSV";
import { SaveCSV } from "../../../csv/SaveCSVForLater";
import AWS, { Credentials } from "aws-sdk";
import Papa from "papaparse";
import NoPropertiesSelectedModal from "../../../Modals/NoPropertiesSelectedModal/NoPropertiesSelectedModal";
import { useOutletContext, useParams } from "react-router-dom";

/**
 * Header buttons in External Form where External Member can Submit a form "In Progress",
 * the Analyst can also Submit a form "In Progress". When the form is completed the 
 * Analyst can merge it with the CSV data from Input Form Page.
 */
export default function SubmitForm({
  isExternalMember,
  showCheckboxes,
  setShowCheckboxes,
  checkboxState,
}) {
  const { formData, setFormData } = useContext(DataRequestContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false); //modal opens when Confirm merge is selected and no properties were checked
  const [isMerged, setIsMerged] = useState(false);
  let status = formData.FileData.Status;
  const { company } = useParams();
  const companyFromURL = company;
  const companyFromLocalStorage = localStorage.getItem("company");
  const getS3 = useOutletContext().getS3;

  //IAM access credentials are used to submit the External Form as this is accessed by an unauthenticated client
  const S3 = new AWS.S3({
    region: process.env.REACT_APP_REGION,
    credentials: new Credentials({
      accessKeyId: process.env.REACT_APP_ACCESS_ID,
      secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
    }),
  });

  const handleSubmit = async () => {
    // Update the formData with new status and DateTime
    const updatedFormData = {
      ...formData,
      FileData: {
        ...formData.FileData,
        Status: "Completed",
        DateTime: new Date().toLocaleString(),
      },
    };

    // Convert updated formData to JSON string
    const jsonData = JSON.stringify(updatedFormData, null, 2);
    const blob = new Blob([jsonData], { type: "application/json" });
    const company = isExternalMember ? companyFromURL : companyFromLocalStorage;

    // Save updated data to S3
    const fileName = updatedFormData.FileData.RequestFormLink;
    try {
      console.log("updatedformdata: ", updatedFormData.FileData);
      const result = await saveJsonToS3Bucket(
        S3,
        blob,
        fileName,
        updatedFormData.FileData,
        company,
        true,
        false
      );
      if (result) {
        console.log("final link", result);
        // Update context and local storage
        setFormData(updatedFormData);
        localStorage.setItem("DataRequest", JSON.stringify(updatedFormData));
        setIsSuccess(true);
        setIsError(false);
      } else {
        throw new Error("Failed to submit data.");
      }
    } catch (error) {
      setIsError(true);
      setErrorMessage(error.message);
    } finally {
      setIsModalOpen(true);
    }
  };

  //  Cancel Merging Data and Hide Checkboxes
  const handleCancel = () => {
    setShowCheckboxes(false);
  };

  //Update the UpdatedDataArray in localstorage with the checked properties
  const updateLocalStorageData = () => {
    const selectedProperties = formData.FileData.PropertiesData.filter(
      (_, index) => checkboxState[index]
    );

    const updatedDataArray = JSON.parse(
      localStorage.getItem("UpdatedDataArray")
    );
    selectedProperties.forEach((selectedProperty) => {
      const index = updatedDataArray.findIndex(
        (item) => item.Property === selectedProperty.Property
      );
      if (index !== -1) {
        updatedDataArray[index] = {
          ...updatedDataArray[index],
          "Value (per property)": selectedProperty["Value (per property)"],
          "Quality (per value)": selectedProperty["Quality (per value)"],
          "Notes (per property)": selectedProperty["Notes (per property)"],
        };
      }
    });

    localStorage.setItem("UpdatedDataArray", JSON.stringify(updatedDataArray));
    localStorage.setItem(
      "formattedDataArray",
      JSON.stringify(updatedDataArray)
    );
  };

  //Merge Date when click on Confirm Merge
  const handleConfirmMerge = async () => {
    //S3 from Cognito is needed here as this action is performed by the Analyst
    const s3Cognito = await getS3();

    const selectedProperties = formData.FileData.PropertiesData.filter(
      (_, index) => checkboxState[index]
    );
    if (selectedProperties.length === 0) {
      setIsWarningModalOpen(true);
      return;
    }

    updateLocalStorageData();

    // Mark selected properties as merged
    const updatedPropertiesData = formData.FileData.PropertiesData.map(
      (property, index) => {
        if (checkboxState[index]) {
          return { ...property, isMerged: true };
        }
        return property;
      }
    );

    //Update the formDate with status Merged and current DateTime
    const updatedFormData = {
      ...formData,
      FileData: {
        ...formData.FileData,
        Status: "Merged",
        DateTime: new Date().toLocaleString(),
        PropertiesData: updatedPropertiesData,
      },
      UpdatedDataArray: selectedProperties,
    };

    //convert updated formData to JSON string
    const jsonData = JSON.stringify(updatedFormData, null, 2);
    const blob = new Blob([jsonData], { type: "application/json" });

    //Convert UpdatedDataArray to CSV
    const csvData = await retrieveData();
    console.log("modified data: ", csvData);
    const formattedCSVData = formatCSVData(csvData);
    const csvString = Papa.unparse(formattedCSVData);

    //Save updated data to S3
    const fileNameDataRequest = updatedFormData.FileData.RequestFormLink;
    const fileNameCSV = updatedFormData.FileData.SnapshotName;

    try {
      const jsonResult = await saveJsonToS3Bucket(
        S3,
        blob,
        fileNameDataRequest,
        formData.FileData,
        company,
        false,
        true
      );

      const csvResult = await SaveCSV(
        s3Cognito,
        fileNameCSV,
        fileNameCSV,
        csvString,
        true
      );
      // console.log("csvResult: ", csvResult);
      //If both are saved successfully then update local storage
      if (jsonResult) {
        if (csvResult) {
          setFormData(updatedFormData);
          localStorage.setItem("DataRequest", JSON.stringify(updatedFormData));
          setIsSuccess(true);
          setIsMerged(true);
        }
      } else {
        throw new Error("Failed to submit data.");
      }
    } catch (error) {
      setIsError(true);
      setIsMerged(false);
      setErrorMessage(error.message);
    } finally {
      setIsModalOpen(true);
    }
  };

  const renderButton = () => {
    if (showCheckboxes) {
      return (
        <>
          <button className="submitform-disabled-button" onClick={handleCancel}>
            Cancel
          </button>
          <button
            className="submitform-green-button-large"
            onClick={handleConfirmMerge}
          >
            Confirm Merge
          </button>
        </>
      );
    } else if (status === "In Progress") {
      return (
        <button className="green-button" style={{width: 86}} onClick={handleSubmit}>
          Submit
        </button>
      );
    } else if (
      isExternalMember &&
      (status === "Completed" || status === "Merged")
    ) {
      return (
        <button className="green-button" onClick={handleSubmit} disabled>
          Submit
        </button>
      );
    } else if (
      !isExternalMember &&
      (status === "Completed" || status === "Merged")
    ) {
      return (
        <button
          className="green-button"
          onClick={() => setShowCheckboxes(true)}
        >
          Merge Data
        </button>
      );
    }
    return null;
  };

  return (
    <>
      {renderButton()}
      <ExternalFormSubmittedModal
        isOpen={isModalOpen}
        isSuccess={isSuccess}
        isError={isError}
        errorMessage={errorMessage}
        isMerged={isMerged}
        onClose={() => setIsModalOpen(false)}
      />
      <NoPropertiesSelectedModal
        isOpen={isWarningModalOpen}
        onClose={() => setIsWarningModalOpen(false)}
      />
    </>
  );
}
